__turbopack_context__.v({
  "base": "tag-module__v37qga__base",
  "bottom-left": "tag-module__v37qga__bottom-left",
  "bottom-right": "tag-module__v37qga__bottom-right",
  "dpe": "tag-module__v37qga__dpe",
  "ideeri-secondary": "tag-module__v37qga__ideeri-secondary",
  "label": "tag-module__v37qga__label",
  "nok": "tag-module__v37qga__nok",
  "ok": "tag-module__v37qga__ok",
  "secondary": "tag-module__v37qga__secondary",
  "small": "tag-module__v37qga__small",
  "tag": "tag-module__v37qga__tag",
  "top-left": "tag-module__v37qga__top-left",
  "top-right": "tag-module__v37qga__top-right",
  "transparent": "tag-module__v37qga__transparent",
});
